"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapAttachment = exports.MediaType = exports.StoryType = void 0;
var StoryType;
(function (StoryType) {
    StoryType["DYNAMIC"] = "TYPE_DYNAMIC";
    StoryType["PUBLIC_USER"] = "TYPE_PUBLIC_USER_STORY";
    StoryType["MAPS"] = "TYPE_MAPS";
    StoryType["PUBLISHER"] = "TYPE_PUBLISHER_STORY";
    StoryType["SPOTLIGHT"] = "TYPE_COMMUNITY";
})(StoryType = exports.StoryType || (exports.StoryType = {}));
var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["VIDEO_NO_SOUND"] = "VIDEO_NO_SOUND";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var SnapAttachment;
(function (SnapAttachment) {
    SnapAttachment["WEB_PAGE"] = "WEB_PAGE";
    SnapAttachment["LONGFORM_VIDEO"] = "LONGFORM_VIDEO";
})(SnapAttachment = exports.SnapAttachment || (exports.SnapAttachment = {}));
//# sourceMappingURL=stories.js.map